

















































import { Vue, Component, Prop } from 'vue-property-decorator';

import eventBus from '@/utils/eventBus';

import CloseModalIcon from '@/components/icons/CloseModal.vue';
import Picture from '@/components/atoms/Picture/Picture.vue';
import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import { MiddlewareRoute } from '@/router/middleware.interface';

@Component({
  components: {
    CloseModalIcon,
    Picture,
    FilledButton
  }
})
export default class DiscardChanges extends Vue {
  @Prop() to!: MiddlewareRoute;
  @Prop() sections!: String[];

  handleClose() {
    eventBus.$emit('closeModal');
  }

  handleDiscard() {
    this.$store.dispatch('business/SET_WIDGET_WARN_CHANGES', false);
    this.handleClose();
    this.$router.push({
      ...this.to,
      params: {
        ...this.to.params,
        discard: 'yes'
      }
    });
  }

  get tPrefix() {
    return 'common.components.widgetConfigFormV2.labels.modals.discardChanges';
  }
}
